import { DebouncedTextInput, Toolbar } from "ra-friendsofbabba";
import { SimpleForm, required } from "react-admin";

import EquipmentTypeInput from "./inputs/EquipmentTypeInput";
import EquipmentTypeOtherInput from "./inputs/EquipmentTypeOtherInput";
import React from "react";

const Form = ({ ...props }) => (
  <SimpleForm
    {...props}
    toolbar={
      <Toolbar
        backTab={3}
        backReference="research-projects"
        backReferenceTarget="research_project_id"
      />
    }
  >
    <EquipmentTypeInput source="equipment_type_id" validate={required()} />
    <EquipmentTypeOtherInput source="equipment_type_other" />
    <DebouncedTextInput
      source="description"
      maxLength={2000}
      validate={[required()]}
      multiline
      fullWidth
    />

    <DebouncedTextInput
      source="relevance"
      validate={[required()]}
      maxLength={2000}
      fullWidth
      multiline
    />
  </SimpleForm>
);

export default Form;
